import { GameAsset } from '../../services/asset-catalogue-service';
import { SolitaireMainScene } from '../../scenes/solitaire-main-scene';
import { PileView } from './pile-view';
import { WastePileViewModel } from './waste-pile-view-model';
import { ResizeMetrics } from '../../resize-metrics';

export class WastePileView extends PileView {
  private get wasteViewModel(): WastePileViewModel {
    return this.viewModel as WastePileViewModel;
  }

  constructor(scene: SolitaireMainScene, x: number, y: number, viewModel: WastePileViewModel) {
    super(scene, x, y, viewModel);
  }

  protected override resizeBackground(resizeMetrics: ResizeMetrics, gameAsset: GameAsset): void {
    const layoutConfig = resizeMetrics.layoutConfig;
    const scalingMetrics = resizeMetrics.scalingMetrics;

    let xPos = (layoutConfig.boardWidth - layoutConfig.gameWidth) * 0.5;
    xPos += (gameAsset.dimensions.width + layoutConfig.hSpacing) * 4.5;
    const yPos = layoutConfig.vPadding;

    this.background.setPosition(
      xPos * scalingMetrics.scaleFactor + scalingMetrics.scaledOffsetX,
      yPos * scalingMetrics.scaleFactor,
    );
    this.background.setDisplaySize(
      gameAsset.dimensions.width * scalingMetrics.scaleFactor,
      gameAsset.dimensions.height * scalingMetrics.scaleFactor,
    );
  }
}
